export const FLAG_GETTING_COST_CENTERS = 'FLAG_GETTING_COST_CENTERS';
export const GET_COST_CENTERS = 'GET_COST_CENTERS';
export const CLEAR_COST_CENTERS = 'CLEAR_COST_CENTERS';
export const FLAG_COST_CENTER_ACTIVITY = 'FLAG_COST_CENTER_ACTIVITY';
export const GET_COST_CENTER = 'GET_COST_CENTER';
export const CLEAR_COST_CENTER = 'CLEAR_COST_CENTER';
